function validateInputOnChangeAndTranslate(event, translations) {
  const input = event.target;
  const error = document.getElementById(`${input.id}-error`);
  const inputValidity = event.target.validity;

  if (inputValidity.valueMissing) {
    error.classList.add("auth__content__form__errors--active");
    input.classList.add("input--error");
    error.textContent = translations.required;
  } else if (inputValidity.patternMismatch) {
    error.classList.add("auth__content__form__errors--active");
    input.classList.add("input--error");
    if (input.id.startsWith("email")) {
      error.textContent = translations.emailPattern;
    }
  } else if (input.maxLength > 0 && input.value.length > input.maxLength) {
    error.classList.add("auth__content__form__errors--active");
    input.classList.add("input--error");
    error.textContent = translations.tooLong + ` ${input.maxLength}`;
  } else if (input.minLength > 0 && input.value.length < input.minLength) {
    error.classList.add("auth__content__form__errors--active");
    input.classList.add("input--error");
    if (input.id === "message") {
      error.textContent = `${translations.messageTooShort} ${input.minLength}`;
    } else if (input.id === "password") {
      error.textContent = translations.passwordTooShort;
    } else {
      error.textContent = translations.tooShort + ` ${input.minLength}`;
    }
  } else if (inputValidity.typeMismatch) {
    error.classList.add("auth__content__form__errors--active");
    input.classList.add("input--error");
    if (input.type === "email") {
      error.textContent = translations.emailPattern;
    }
  } else if (inputValidity.valid) {
    error.classList.remove("auth__content__form__errors--active");
    input.classList.remove("input--error");
  }
}

function validateInputOnSubmitAndTranslate(event, translations) {
  event.preventDefault();

  validateInputOnChangeAndTranslate(event, translations);
}
